// src/App/Animations/HeroAnimation.js
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(SplitText);

import Animation from "./Animation.js";

export default class SubtitleAnimation extends Animation {
  constructor(element) {
    super(element);
  }

  setInitialState() {
    this.text = this.element.querySelector("span");
    this.splitText = SplitText.create(this.text, {
      linesClass: "line",
    });
    this.background = this.element.querySelector(".subtitle__bg");
    this.svg = this.element.querySelector("svg");

    gsap.set(this.background, { scaleX: 0, transformOrigin: "left center" });
    gsap.set(this.splitText.chars, { yPercent: 110 });
    gsap.set(this.svg, { yPercent: 100 });
  }

  createTimeline() {
    const tl = gsap.timeline({ paused: true });

    tl.to(this.background, {
      scaleX: 1,
      ease: "power3.out",
      duration: 0.8,
    })
      .to(this.splitText.chars, {
        yPercent: 0,
        stagger: {
          // amount: 0.25,
          each: 0.03,
          // from: "random",
        },
        ease: "power3.out",
      },'>-0.65')
      .to(
        this.svg,
        {
          yPercent: 0,
          // duration: 0.25,
          ease: "power3.out",
        },">-0.3"
      );

    return tl;
  }
}
